import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';

@Injectable()
export class UpsellResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([]);
}
